// extracted by mini-css-extract-plugin
module.exports = {"textBox":"styles_textBox__2pZtu","editor":"styles_editor__3uZNV","error":"styles_error__3Zokk"};